import { render } from "./Poems.vue?vue&type=template&id=76e2955a&scoped=true"
import script from "./Poems.vue?vue&type=script&lang=js"
export * from "./Poems.vue?vue&type=script&lang=js"

import "./Poems.vue?vue&type=style&index=0&id=76e2955a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76e2955a"]])

export default __exports__